export default __webpack_public_path__ + "static/media/graph3.af122a61.png";